import React from "react";

import { createInstance, useMatomo } from "@datapunt/matomo-tracker-react";

const Instance = createInstance({
  urlBase: process.env.REACT_APP_TRACKER_URL,
  siteId: process.env.REACT_APP_MATAMO_SITE_ID,
  trackerUrl: `${process.env.REACT_APP_TRACKER_URL}matomo.php`, // optional, default value: `${urlBase}matomo.php`
  srcUrl: `${process.env.REACT_APP_TRACKER_URL}matomo.js`, // optional, default value: `${urlBase}matomo.js`
});

const MatomoContext = React.createContext({});

const MatomoCustomProvider = ({ children }) => {
  const {
    trackPageView,
    trackEvent,
    trackSiteSearch,
    pushInstruction,
  } = useMatomo();

  const trackUserPage = (documentTitle = "", href = "", customDimensions) => {
    trackPageView({
      documentTitle: documentTitle,
      href: `${window.location.protocol}//${window.location.host}${href}`,
      customDimensions: customDimensions,
    });
  };

  const trackUserEvent = params => {
    trackEvent(params);
  };

  const trackSearch = params => {
    trackSiteSearch(params);
  };

  const setLoggedInUser = (
    userId = "",
    email = "",
    displayName = "",
    currentOrg = "",
    role = "",
  ) => {
    if (userId === "") {
      pushInstruction("resetUserId");
      pushInstruction("appendToTrackingUrl", "new_visit=1");
      pushInstruction("trackPageView");
      pushInstruction("appendToTrackingUrl", "");
      pushInstruction("setCustomDimension", 1, "", "visit");
      pushInstruction("setCustomDimension", 2, "", "visit");
      pushInstruction("setCustomDimension", 3, "", "visit");
      pushInstruction("setCustomDimension", 4, "", "visit");
    } else {
      pushInstruction("setUserId", userId);
      pushInstruction("setCustomDimension", 1, displayName, "visit");
      pushInstruction("setCustomDimension", 2, email, "visit");
      pushInstruction("setCustomDimension", 3, currentOrg, "visit");
      pushInstruction("setCustomDimension", 4, role, "visit");
    }
  };

  const trackAssetDetails = assetPrice => {
    pushInstruction("setCustomDimension", 5, assetPrice, "page");
  };

  return (
    <MatomoContext.Provider
      value={{
        trackUserPage,
        trackUserEvent,
        trackSearch,
        setLoggedInUser,
        trackAssetDetails,
      }}
    >
      {children}
    </MatomoContext.Provider>
  );
};

export { MatomoContext, MatomoCustomProvider, Instance };
